"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useError = function useError() {
  var _a = react_1.useState(null),
      error = _a[0],
      setError = _a[1];

  react_1.useEffect(function () {
    if (error) {
      throw error;
    }
  }, [error]);
  var dispatchError = react_1.useCallback(function (err) {
    setError(err);
  }, []);
  return dispatchError;
};

exports["default"] = useError;